// extracted by mini-css-extract-plugin
module.exports = {"tour-card-image":"TourCardMedia_tour-card-image__2BgGl","tour-card-image-link":"TourCardMedia_tour-card-image-link__upCdP"};